import { isEmpty, pick } from "@/utils";
import $appConfig from "@/config/app.config";

const { snackbar } = $appConfig;

/**
|--------------------------------------------------
| Module state
|--------------------------------------------------
*/
const state = {
  snackbar: {
    value: false,
    message: "",
    hide: false,
    type: snackbar.snackbarTypes.error,
    icon: snackbar.config.error.icon,
    previousError: "",
  },
  routerHistory: [],
};

/**
 * Mutations constants
 */
const SET_SNACKBAR = "SET_SNACKBAR_ERROR";
const HIDE_SNACKBAR = "HIDE_SNACKBAR";
const SET_ROUTER_HISTORY = "SET_ROUTER_HISTORY";
const REMOVE_ROUTER_HISTORY = "REMOVE_ROUTER_HISTORY";

/**
|--------------------------------------------------
| Mutations
|--------------------------------------------------
*/
const mutations = {
  [SET_SNACKBAR](state, data) {
    state.snackbar = { ...state.snackbar, ...data };
  },
  /**
   * Overides api error message visualisation in snackbar globally
   */
  [HIDE_SNACKBAR](state, hide) {
    state.snackbar.hide = hide;
  },
  [SET_ROUTER_HISTORY](state, data) {
    const history = pick(data, ["fullPath", "path", "name"]);
    if (!isEmpty(data)) {
      state.routerHistory.push(history);
    }
  },
  [REMOVE_ROUTER_HISTORY](state, data = []) {
    state.routerHistory = data;
  },
};

/**
|--------------------------------------------------
| Actions (Asynchronous)
|--------------------------------------------------
*/
const actions = {
  /**
   * Handles global snackbar
   */
  setSnackbar({ commit }, data) {
    commit(SET_SNACKBAR, data);
  },
};

/**
|--------------------------------------------------
| Getters to access state properties
|--------------------------------------------------
*/
const getters = {
  snackbar({ snackbar }) {
    return snackbar;
  },
  snackbarError({ snackbar }) {
    return snackbar?.message ?? "";
  },
  previousRoute({ routerHistory }) {
    return routerHistory[routerHistory.length - 1];
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
};
